import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numeroAporte',
    standalone: false
})

export class NumeroAportePipe implements PipeTransform {

transform(value: string, args: any[]): string {
    return`${value}`.padStart(3, '0');
   }
}
